var map = {
	"./arbitrum.png": 28195,
	"./avalanche.png": 7866,
	"./ban.png": 10534,
	"./bsc.png": 18489,
	"./ethereum.png": 69502,
	"./optimism.png": 97767,
	"./polygon.png": 43247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70348;